var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisivel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#adb5bd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2380 4314 c-832 -76 -1577 -587 -2062 -1414 -93 -159 -158 -299 -158 -342 0 -77 205 -442 373 -667 448 -596 1022 -956 1702 -1067 153 -25 494 -25 655 0 519 81 1008 335 1405 731 240 239 442 521 601 838 45 90 64 140 64 166 0 92 -230 488 -431 742 -99 125 -352 380 -469 472 -355 281 -749 457 -1168 522 -95 15 -423 27 -512 19z m370 -324 c678 -71 1307 -497 1725 -1169 40 -64 89 -149 109 -188 l36 -73 -36 -72 c-51 -101 -155 -267 -237 -378 -447 -606 -1055 -957 -1707 -987 -765 -34 -1518 409 -1993 1173 -41 65 -91 152 -111 192 l-36 72 36 73 c20 39 70 125 110 190 379 609 936 1019 1550 1142 169 33 380 43 554 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 3665 c-276 -44 -542 -204 -711 -427 -321 -427 -301 -1008 49 -1415 243 -282 648 -429 1011 -369 500 84 870 461 941 961 55 387 -117 798 -432 1036 -245 184 -555 262 -858 214z m370 -328 c100 -28 168 -57 243 -107 426 -278 490 -876 132 -1235 -359 -358 -957 -294 -1235 132 -89 136 -125 259 -125 433 0 174 36 297 124 432 119 182 304 308 521 354 80 17 262 12 340 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisivel);
export default __webpack_public_path__ + "static/media/visivel.197ddb10fc1125f180fa6bdc3e892d1b.svg";
export { ForwardRef as ReactComponent };